import React from "react";
import classNames from "../../classNames";

const iconSize = "clamp(2.25rem, 10vw, 3rem)";

export default function PreviewFormModalHeader({
  title,
  description,
  icon = "bi bi-eye",
  type = "primary",
}) {
  return (
    <div
      className={classNames(
        "d-flex align-items-start rounded-top-3",
        "bg-light border-0 border-bottom",
        "gap-2 gap-sm-3 p-3",
      )}
    >
      <div
        className={classNames(
          "d-flex align-items-center justify-content-center rounded-2 rounded-sm-3 flex-shrink-0 bg-light",
          "text-" + type,
        )}
        style={{
          width: iconSize,
          height: iconSize,
          minWidth: iconSize,
          minHeight: iconSize,
          textAlign: "center",
        }}
      >
        <i
          className={classNames(icon, "fs-6 fs-sm-5")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
          aria-hidden
        />
      </div>
      <div className="d-flex flex-column min-w-0 flex-grow-1 overflow-hidden">
        <h5
          className="m-0 mb-1 fw-bold text-primary text-break"
          id="preview-modal-title"
        >
          {title}
        </h5>
        <p
          className="m-0 text-muted small text-break"
          style={{ maxWidth: "32rem", lineHeight: 1.4, fontSize: "13px" }}
          id="preview-modal-desc"
        >
          {description}
        </p>
      </div>
    </div>
  );
}
